<!--
 * @Author: 王佳宾
 * @Date: 2022-09-06 16:47:38
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-02-21 15:17:42
 * @Description:
 * @FilePath: \web\src\components\ProjectLibrary\main\orenodeSearch\keySearch\mineralTypeId.vue
-->
<template>
  <section class="mineral-type-com-id" v-show="visible">
    <a-checkbox-group v-model:value="selectValue">
      <a-checkbox :value="item.id" v-for="item in list" :key="item.name"><span :title="item.name">{{
        item.name.length > 3 ? item.name.slice(0, 2) + '...' : item.name}}</span></a-checkbox>
    </a-checkbox-group>

    <section class="btns">
      <section class="btns-l">
        <a-button type="primary" @click="reset">重置</a-button>
        <a-button v-if="allInType" type="primary" class="all-in" @click="allIn">全选</a-button>
      </section>
      <section class="btns-r">
        <a-button type="primary" @click="close">取消</a-button>
        <a-button type="primary" class="r" @click="submit">确定</a-button>
      </section>
    </section>
  </section>
</template>

<script setup>
import { defineProps, toRefs, ref, defineEmits, defineExpose, } from 'vue';

const props = defineProps({
  allInType: {
    type: String,
    default: false,
  },
  list: {
    type: Array,
    default: [],
  },
  selectList: {
    type: Array,
    default: [],
  },
  visible: {
    type: Boolean,
    default: false,
  },
});
const { list, visible, } = toRefs(props);

// emit
const emit = defineEmits(['close', 'submit',]);

const selectValue = ref(props.selectList);

const reset = () => {
  selectValue.value = [];
};
/**
 * 全选
 */
const allIn = () => {
  list.value.forEach((item) => {
    if (selectValue.value.indexOf(item.id) === -1) {
      selectValue.value.push(item.id)
    }
  })
}

const close = () => {
  emit('close');
};

const submit = () => {
  emit('submit', selectValue.value.length ? selectValue.value : null);
};

defineExpose({
  reset,
});

</script>

<style lang="scss">
.mineral-type-com-id {
  top: 0.58rem;
  left: 0rem;
  width: 4.85rem;
  // height: 3rem;
  position: absolute;

  padding: 0.13rem;
  // background-image: url(~@/static/images/projectlibrary/toolbar/bg_bigger_icon.png);
  background-color: #514b4b;
  background-size: 100% 100%;
  z-index: 10;

  .ant-checkbox-group {
    display: flex;
    flex-wrap: wrap;

    .ant-checkbox-wrapper {
      width: 20%;
      margin-left: 0;
      font-size: .18rem;
      color: #fff;
    }
  }

  .btns {
    display: flex;
    justify-content: space-between;
    margin-top: 0.1rem;

    .ant-btn {
      padding: .0rem .13rem;
      height: 0.3rem;

      span {
        line-height: 0;
      }
    }

    .btns-l {
      .all-in {
        margin-left: 0.1rem;
        color: rgb(42, 2, 188);
      }
    }

    .btns-r {
      .r {
        margin-left: 0.1rem;
        color: rgb(42, 2, 188);
      }
    }
  }
}
</style>